<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { NXGDSButton, NXGDSButtonVariants } from '@nsftx/seven-nxg-design-system'
import { getShortcutKeys, useShortcutsStore } from '@nsftx/seven-nxg-retail-vue-sdk'
import { useWidgetsStore } from '@/stores/widgets/widgetsStore'
import SSLatestBetslipsTable from './SSLatestBetslipsTable.vue'
import { useLatestBetslipsDataTable } from '@/composables/useLatestBetslipsTable/useLatestBetslipsTable.ts'
import SSShortcutKeys from '@/ui/components/SSShortcutKeys.vue'

const { t } = useI18n({ useScope: 'global' })
const router = useRouter()
const { toggleLatestBetslips } = useWidgetsStore()
const { latestBetslipsDataTable } = useLatestBetslipsDataTable()
const { getAppShortcutsByAction } = useShortcutsStore()

const actionShortcut = computed(
  () => getAppShortcutsByAction('TOGGLE_LATEST_BETSLIPS')?.shortcut[0],
)
const actionShortcutKeys = computed(() =>
  actionShortcut.value ? getShortcutKeys(actionShortcut.value) : [],
)

const navigateToLatestBetslipsSettings = () => {
  router.push({ name: 'settingsLastTickets' })
}
</script>

<template>
  <div class="ss-latest-betslips">
    <div class="ss-latest-betslips__container">
      <div class="ss-latest-betslips__header">
        <div class="ss-latest-betslips__header__left ss-flex-center ss-gap-xs">
          <p>{{ t('widget_latest_betslips') }}</p>
          <SSShortcutKeys v-if="actionShortcutKeys.length" :keys="actionShortcutKeys" />
        </div>
        <div class="ss-latest-betslips__header__right ss-flex-center ss-gap-sm">
          <NXGDSButton
            :variant="NXGDSButtonVariants.ghost"
            icon="settings-a"
            size="sm"
            @click="navigateToLatestBetslipsSettings"
          />
          <NXGDSButton
            :variant="NXGDSButtonVariants.ghost"
            icon="close-a"
            size="sm"
            @click="toggleLatestBetslips"
          />
        </div>
      </div>
      <SSLatestBetslipsTable
        v-if="latestBetslipsDataTable.length"
        class="ss-latest-betslips__table"
        :latest-betslips-data-table
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '@/styles/mixins' as mixins;

.ss-latest-betslips {
  height: 100%;

  &__container {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    padding: var(--nxgds-alias-spacing-xs);
    border: 2px solid var(--nxgds-mapped-color-border-primary);
    border-radius: var(--nxgds-alias-radius-corner-md);
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--nxgds-alias-spacing-xs) var(--nxgds-alias-spacing-2xs)
      var(--nxgds-alias-spacing-sm);
    color: var(--nxgds-mapped-color-text-secondary);
    @include mixins.typography('h4-medium');
  }

  &__table {
    flex: 1;
    overflow: auto;
  }
}
</style>
